import { render, staticRenderFns } from "./NozamaStats.vue?vue&type=template&id=2422739a&scoped=true"
import script from "./NozamaStats.vue?vue&type=script&lang=js"
export * from "./NozamaStats.vue?vue&type=script&lang=js"
import style0 from "./NozamaStats.vue?vue&type=style&index=0&id=2422739a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2422739a",
  null
  
)

export default component.exports